export function formatBytes(bytes) {
	if (bytes == null || Number.isNaN(Number(bytes))) return "—";
	const n = Number(bytes);
	if (n === 0) return "0 B";
	const k = 1024;
	const sizes = ["B", "KB", "MB", "GB", "TB"];
	const i = Math.floor(Math.log(n) / Math.log(k));
	return `${new Intl.NumberFormat("pt-BR", {
		maximumFractionDigits: 2,
	}).format(n / Math.pow(k, i))} ${sizes[i]}`;
}

export function formatPercent(value) {
	return `${new Intl.NumberFormat("pt-BR", {
		minimumFractionDigits: 1,
		maximumFractionDigits: 1,
	}).format(Number(value) || 0)}%`;
}

export function formatUptime(seconds) {
	if (seconds == null || Number.isNaN(Number(seconds))) return "—";
	const s = Math.floor(Number(seconds));
	const d = Math.floor(s / 86400);
	const h = Math.floor((s % 86400) / 3600);
	const m = Math.floor((s % 3600) / 60);
	if (d > 0) return `${d}d ${h}h`;
	if (h > 0) return `${h}h ${m}m`;
	return `${m}m`;
}
